import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import PropTypes from 'prop-types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '100%',
  },
}));

const DropDownPicker = React.memo(
  ({ children, className, menuArray, style, label, input, meta: { touched, error }, ...props }) => {
    const classes = useStyles();
    return (
      <FormControl
        error={!!error && touched}
        className={clsx(classes.formControl, className)}
        style={style}
      >
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
          {label}
        </InputLabel>
        <Select {...props} {...input} MenuProps={MenuProps}>
          {menuArray &&
            menuArray.map(v => (
              <MenuItem key={v.value} value={v.value}>
                {v.label}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{!!error && touched ? error : ''}</FormHelperText>
      </FormControl>
    );
  },
);

DropDownPicker.defaultProps = {
  meta: {
    touched: false,
    error: '',
  },
  input: {},
  style: undefined,
  className: undefined,
  children: undefined,
};

DropDownPicker.propTypes = {
  style: PropTypes.object,
  label: PropTypes.string.isRequired,
  input: PropTypes.object,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  className: PropTypes.string,
  children: PropTypes.node,
  menuArray: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
};

export default DropDownPicker;
